import moment from 'moment'

export enum DateFormat {
  DEFAULT = 'DD-MM-YYYY',
  DEFAULT_REVESE = 'YYYY-MM-DD',
  DEFAULT_DATE_UI = 'DD MMM YY',
  DEFAULT_DATE_SHORT_TIME = 'DD MMM YY HH:mm',
  DEFAULT_DATE_TIME_UI = 'DD MMM YY hh:mm A',
  DEFAULT_DATE_SHORT_TIME_UI = 'DD MMM YY hh:mm',
  DEFAULT_DATE_TIME_DISPLAY = 'DD MMM YY hh:mma',
  DEFAULT_TIME = 'hh:mma',
  DEFAULT_DIFF_TIME = 'h[h] m[m]',
  DEFAULT_DATE_CSV_BILLING = 'DDMMMYY',
  DEFAULT_DATE_MDUM = 'DD MMM YYYY',
  DEFAULT_DATE = 'DD-MMM-YYYY',
  DEFAULT_DATE_TIME = 'hh:mma DD MMM YY',
}

export function formatDate(date: string, format: DateFormat = DateFormat.DEFAULT): string {
  const momentObj = moment.utc(date)

  if (!momentObj.isValid()) {
    return ''
  }

  return momentObj.format(format)
}

export function formatLocalDate(date: string, format: DateFormat = DateFormat.DEFAULT): string {
  const momentObj = moment.utc(date).local()

  if (!momentObj.isValid()) {
    return ''
  }

  return momentObj.format(format)
}

export function getFormatedTime(utcDate): string {
  // This function will return Time from Utc Date
  // Input utcDate - "2018-08-01T08:55:00.000Z"
  // Output time - "02:25pm"
  const momentObj = moment.utc(utcDate)
  if (!momentObj.isValid()) {
    return ''
  }

  return momentObj.local().format(DateFormat.DEFAULT_TIME)
}

export function getFormatedDate(utcDate): string {
  // This function will return Time from Utc Date
  // Input utcDate - "2018-08-01T08:55:00.000Z"
  // Output time - "02:25pm 19 Oct 21"
  const momentObj = moment.utc(utcDate)
  if (!momentObj.isValid()) {
    return ''
  }
  return momentObj.local().format(DateFormat.DEFAULT_DATE_TIME)
}

export function formatDateWithYear(
  date: string,
  format: DateFormat = DateFormat.DEFAULT_DATE,
): string {
  const momentObj = moment(date, format)
  if (!momentObj.isValid()) {
    return ''
  }
  return momentObj.format('DD MMM YYYY')
}

export function formatDateWithoutYear(
  date: string,
  format: DateFormat = DateFormat.DEFAULT_DATE,
): string {
  const momentObj = moment(date, format)
  if (!momentObj.isValid()) {
    return ''
  }
  return momentObj.format('DD MMM')
}

export function formatDateFullMonthWithoutYear(
  date: string,
  format: DateFormat = DateFormat.DEFAULT_DATE,
): string {
  const momentObj = moment(date, format)
  if (!momentObj.isValid()) {
    return ''
  }
  return momentObj.format('DD MMMM')
}

export function getDiffFromDates(
  startDate: string,
  endDate: string,
  format: DateFormat = DateFormat.DEFAULT_DIFF_TIME,
): string {
  const startDateMomentObj = moment(startDate)
  const endDateMomentObj = moment(endDate)
  if (!startDateMomentObj.isValid() || !endDateMomentObj.isValid()) {
    return ''
  }
  const miliSecond = endDateMomentObj.diff(startDateMomentObj)
  return moment.utc(miliSecond).format(format)
}
